module.exports = __webpack_public_path__ + "img/urs_bubble.4e23c570.svg";